import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { mainroutes } from '../routes';

class MainContent extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    return (
      <Switch>
        {mainroutes.map((route, idx) => {
          return (
            route.component && (
              <Route
                key={idx}
                path={route.path}
                exact={route.exact}
                name={route.name}
                render={(props) => <route.component {...props} />}
              />
            )
          );
        })}
        <Redirect from="/" to="/main" />
      </Switch>
    );
  }
}

export default React.memo(MainContent);
